module.exports = __webpack_public_path__ + "img/transfusion_icon.a84249b2.svg";